import React from 'react'
import { Outlet } from 'react-router-dom'

import yamadumiAuth from '../../Auth'
import { useUnsafeOnceCall } from '../hooks'
import Login from '../../pages/systems/Login'

export function UserAuthentication() {
  const [content, setContent] = React.useState<React.ReactNode>()
  const onceCall = useUnsafeOnceCall()

  React.useLayoutEffect(() => {
    if (!yamadumiAuth.hasToken()) {
      setContent(<Login />)
    } else if (!yamadumiAuth.authenticated()) {
      console.log('トークンの有効期限が切れています。トークンの更新を行います。')
      onceCall(() => {
        // React.StrictModeでは、開発環境においてコンポーネントを２回マウントする。
        // トークンのリフレッシュは２回連続で送っても問題は無いが、
        // トークンを２度生成することになり負荷がかかるため、１度だけ呼ぶようにする。
        yamadumiAuth.refreshAuthenticate()
          .then(() => setContent(<Outlet />))
          .catch(() => setContent(<Login />))
      })
    } else {
      setContent(<Outlet />)
    }
  }, [window.location.pathname])

  return <>{content}</>
}
